import React, { useState, useEffect } from 'react'
import MedicalHistorySection from '../../../components/ProfileForm/MedicalHistorySection'

const EmergencyContactInfo = ({ emergencyContact, setEmergencyContact }) => {

  return (
    <div className="space-y-6">
      {/* Emergency Contact */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Emergency Contact</h2>

        <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-6 sm:gap-x-6">
          <div className="sm:col-span-3">
            <label
              htmlFor="emergencyName"
              className="block text-sm/6 font-medium"
            >
              Name
            </label>
            <input
              type="text"
              id="emergencyName"
              name="emergencyName"
              required
              value={emergencyContact.emergencyName}
              onChange={(e) => {
                setEmergencyContact((prev) => ({
                  ...prev,
                  emergencyName: e.target.value,
                }))
              }}
              placeholder="Jane Smith"
              className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
            />
          </div>

          <div className="sm:col-span-3">
            <label
              htmlFor="emergencyPhone"
              className="block text-sm/6 font-medium"
            >
              Phone Number
            </label>
            <input
              type="tel"
              id="emergencyPhone"
              name="emergencyPhone"
              required
              value={emergencyContact.emergencyPhone}
              onChange={(e) => {
                setEmergencyContact((prev) => ({
                  ...prev,
                  emergencyPhone: e.target.value,
                }))
              }}
              placeholder="07700 900456"
              className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmergencyContactInfo
